const _ = require("lodash");

const instructionsIn = [
	{
		transform: "translate3d(52%, -15%, 0) scale3d(0.05, 0.025, 1)",
		opacity: 0,
		offset: 0,
	},
	{
		transform: "translate3d(50%, -15%, 0) scale3d(0.1, 0.05, 1)",
		opacity: 0.5,
		offset: 0.1,
	},
	{
		transform: "translate3d(30%, -15%, 0) scale3d(0.5, 0.3, 1)",
		opacity: 1,
		offset: 0.2,
	},
	{
		transform: "translate3d(10%, -10%, 0) scale3d(0.8, 0.5, 1)",
		opacity: 1,
		offset: 0.4,
	},
	{
		transform: "translate3d(0, 0, 0) scale3d(0.9, 0.8, 1)",
		opacity: 1,
		offset: 0.6,
	},
	{transform: "translate3d(0, 0, 0) scale3d(1, 1, 1)", opacity: 1, offset: 1},
];

const instructionsOut = [
	{transform: "translate3d(0, 0, 0) scale3d(1, 1, 1)", opacity: 1, offset: 0},
	{
		transform: "translate3d(0, 0, 0) scale3d(0.9, 0.8, 1)",
		opacity: 1,
		offset: 0.2,
	},
	{
		transform: "translate3d(10%, -10%, 0) scale3d(0.8, 0.5, 1)",
		opacity: 1,
		offset: 0.4,
	},
	{
		transform: "translate3d(30%, -15%, 0) scale3d(0.5, 0.3, 1)",
		opacity: 1,
		offset: 0.6,
	},
	{
		transform: "translate3d(50%, -15%, 0) scale3d(0.1, 0.05, 1)",
		opacity: 0.5,
		offset: 0.9,
	},
	{
		transform: "translate3d(52%, -15%, 0) scale3d(0.05, 0.025, 1)",
		opacity: 0,
		offset: 1,
	},
];

const tutorialIn = [
	{
		transform: "translate3d(25%, -80%, 0) scale3d(0.05, 0.025, 1)",
		opacity: 0,
		offset: 0,
	},
	{
		transform: "translate3d(20%, -60%, 0) scale3d(0.1, 0.05, 1)",
		opacity: 0.5,
		offset: 0.1,
	},
	{
		transform: "translate3d(15%, -30%, 0) scale3d(0.5, 0.3, 1)",
		opacity: 1,
		offset: 0.2,
	},
	{
		transform: "translate3d(5%, -10%, 0) scale3d(0.8, 0.5, 1)",
		opacity: 1,
		offset: 0.4,
	},
	{
		transform: "translate3d(0, 0, 0) scale3d(0.9, 0.8, 1)",
		opacity: 1,
		offset: 0.6,
	},
	{transform: "translate3d(0, 0, 0) scale3d(1, 1, 1)", opacity: 1, offset: 1},
];

const tutorialOut = [
	{transform: "translate3d(0, 0, 0) scale3d(1, 1, 1)", opacity: 1, offset: 0},
	{
		transform: "translate3d(0, 0, 0) scale3d(0.9, 0.8, 1)",
		opacity: 1,
		offset: 0.2,
	},
	{
		transform: "translate3d(5%, -10%, 0) scale3d(0.8, 0.5, 1)",
		opacity: 1,
		offset: 0.4,
	},
	{
		transform: "translate3d(15%, -30%, 0) scale3d(0.5, 0.3, 1)",
		opacity: 1,
		offset: 0.6,
	},
	{
		transform: "translate3d(20%, -60%, 0) scale3d(0.1, 0.05, 1)",
		opacity: 0.5,
		offset: 0.9,
	},
	{
		transform: "translate3d(25%, -80%, 0) scale3d(0.05, 0.025, 1)",
		opacity: 0,
		offset: 1,
	},
];

const shake = [
	{transform: "translate3d(0, 0, 0)", offset: 0},
	{transform: "translate3d(1%, 0, 0)", offset: 0.1},
	{transform: "translate3d(2%, 0, 0)", offset: 0.2},
	{transform: "translate3d(-4%, 0, 0)", offset: 0.3},
	{transform: "translate3d(4%, 0, 0)", offset: 0.4},
	{transform: "translate3d(-4%, 0, 0)", offset: 0.5},
	{transform: "translate3d(4%, 0, 0)", offset: 0.6},
	{transform: "translate3d(-4%, 0, 0)", offset: 0.7},
	{transform: "translate3d(2%, 0, 0)", offset: 0.8},
	{transform: "translate3d(1%, 0, 0)", offset: 0.9},
	{transform: "translate3d(0, 0, 0)", offset: 1},
];

const progressStarPulse = [
	{top: "110%", offset: 0},
	{top: "120%", offset: 0.5},
	{top: "110%", offset: 0.7},
	{top: "100%", offset: 0.9},
	{top: "105%", offset: 1},
];

const shopExpand = [
	{transform: "translate3d(0%, 0, 0)", zIndex: 101},
	{transform: "translate3d(25%, 0, 0)", zIndex: 101},
	{transform: "translate3d(50%, 0, 0)", zIndex: 101},
	{transform: "translate3d(73%, 0, 0)", zIndex: 101},
];

const shopRetract = [
	{transform: "translate3d(0%, 0, 0)", zIndex: 101},
	{transform: "translate3d(-25%, 0, 0)", zIndex: 101},
	{transform: "translate3d(-50%, 0, 0)", zIndex: 101},
	{transform: "translate3d(-73%, 0, 0)", zIndex: 101},
];

const backdropFadeIn = [
	{background: "rgba(0, 0, 0, 0)", visibility: "visible"},
	{background: "rgba(0, 0, 0, 0.075)", visibility: "visible"},
	{background: "rgba(0, 0, 0, 0.125)", visibility: "visible"},
	{background: "rgba(0, 0, 0, 0.2)", visibility: "visible"},
];

const backdropFadeOut = [
	{background: "rgba(0, 0, 0, 0.2)"},
	{background: "rgba(0, 0, 0, 0.125)"},
	{background: "rgba(0, 0, 0, 0.075)"},
	{background: "rgba(0, 0, 0, 0)"},
];

const entryFieldGlow = [
	{boxShadow: "0 0 0.5rem rgba(237,25,65,0.5)"},
	{boxShadow: "0 0 1rem rgba(237,25,65,0.8)"},
	{boxShadow: "0 0 1.5rem rgba(237,25,65,1)"},
	{boxShadow: "0 0 1rem rgba(237,25,65,0.8)"},
	{boxShadow: "0 0 0.5rem rgba(237,25,65,0.5)"},
];

const usernameGlow = [
	{boxShadow: "0 0 1px red"},
	{boxShadow: "0 0 2px red"},
	{boxShadow: "0 0 4px red"},
	{boxShadow: "0 0 2px red"},
	{boxShadow: "0 0 1px red"},
];

const checkboxGrow = [
	{transform: "scale(0.9, 0.9)"},
	{transform: "scale(0.95, 0.95)"},
	{transform: "scale(1, 1)"},
	{transform: "scale(1.1, 1.1)"},
	{transform: "scale(1.15, 1.15)"},
	{transform: "scale(1.1, 1.1)"},
	{transform: "scale(1, 1)"},
	{transform: "scale(0.95, 0.95)"},
	{transform: "scale(0.9, 0.9)"},
	{transform: "scale(0.95, 0.95)"},
];

const starPop = [
	{transform: "scale(0)", offset: 0},
	{transform: "scale(0.3)", offset: 0.1},
	{transform: "scale(0.7)", offset: 0.6},
	{transform: "scale(1.3)", offset: 0.85},
	{transform: "scale(1)", offset: 1},
];

const celestialPop = [
	{transform: "scale(0)", offset: 0},
	{transform: "scale(0.3)", offset: 0.1},
	{transform: "scale(0.7)", offset: 0.6},
	{transform: "scale(1.3)", offset: 0.85},
	{transform: "scale(1)", offset: 1},
];

const glide = [
	{transform: "translateX(0%)", offset: 0},
	{transform: "translateX(0%)", offset: 0.25},
	{transform: "translateX(60%)", offset: 0.3},
	{transform: "translateX(60%)", offset: 0.55},
	{transform: "translateX(120%)", offset: 0.6},
	{transform: "translateX(120%)", offset: 0.85},
	{transform: "translateX(0%)", offset: 1},
];

const chapterPathMakeHopKeyframes = (from, to, options) => {
	const {backwards = false, height = 25} = options || {};
	const x0 = from.x;
	const y0 = from.y;
	const x1 = to.x;
	const y1 = to.y;
	const k = Math.min(from.y, to.y) - height;
	// use (lots of) math to figure out equation for parabola passing through x0,y1 and x1,y1 with a vertex of k
	// NOTE: We don't know why the square roots have the signs they do, but it works, so don't change it unless
	// you've tested all the cases or have gone through the math to figure out why.
	const y0mk = y0 - k;
	const y1mk = y1 - k;
	const diffX = x0 - x1;
	const thirdTerm = 2 * Math.sqrt(y0mk * y1mk);
	const numerator = y0mk + y1mk + thirdTerm; // alternative sign from sqrt would be `y0mk + y1mk - thirdTerm`
	const denominator = diffX * diffX;
	const a = numerator / denominator;
	const h1 = x0 - Math.sqrt((y0 - k) / a);
	const h2 = x0 + Math.sqrt((y0 - k) / a);
	const h = backwards ? h1 : h2;
	const getXFromT = t => (1 - t) * x0 + t * x1;
	const getYFromT = t => {
		const x = getXFromT(t);
		return a * (x - h) ** 2 + k;
	};
	const getFrameDataFromT = t => ({
		x: getXFromT(t),
		y: getYFromT(t),
		t,
	});
	const timeResolution = 0.1;
	const data = _.range(0, 1, timeResolution).map(getFrameDataFromT);
	const initStyle = {
		left: `calc(${x0}px - 4.25rem)`,
		top: `calc(${y0}px - 4.25rem)`,
	};
	const finalStyle = {
		left: `calc(${x1}px - 4.25rem)`,
		top: `calc(${y1}px - 4.25rem)`,
	};
	return [
		{
			...initStyle,
			transform: "none",
			offset: 0,
		},
		{
			...initStyle,
			transform: "translateY(20%) scaleY(0.6)",
			offset: 0.2,
		},
		{
			...initStyle,
			transform: "scaleY(1)",
			offset: 0.29,
		},
		...data.map(({x, y, t}) => ({
			left: `calc(${x}px - 4.25rem)`,
			top: `calc(${y}px - 4.25rem)`,
			transform: "scaleY(1)",
			offset: 0.3 + 0.6 * t,
		})),
		{
			...finalStyle,
			transform: "translateY(20%) scaleY(0.6)",
			offset: 0.9,
		},
		{
			...finalStyle,
			transform: "none",
			offset: 1,
		},
	];
};

const chapterPath = {
	lookAtMe: {
		keyframes: [
			{transform: "none", offset: 0},
			{transform: "translateY(20%) scaleY(0.6)", offset: 0.2},
			{transform: "translateY(-65%)", offset: 0.3},
			{transform: "translateY(-100%)", offset: 0.5},
			{transform: "translateY(-100%)", offset: 0.55},
			{transform: "translateY(-65%)", offset: 0.75},
			{transform: "translateY(20%) scaleY(0.6)", offset: 0.9},
			{transform: "none", offset: 1},
		],
		options: {
			duration: 700,
			easing: "linear",
			fill: "none",
		},
	},
	idleBounce: {
		keyframes: [
			{transform: "none", offset: 0},
			{transform: "translateY(7%) scaleY(0.85)", offset: 0.2},
			{transform: "translateY(-3%)", offset: 0.3},
			{transform: "translateY(-5%)", offset: 0.5},
			{transform: "translateY(-5%)", offset: 0.55},
			{transform: "translateY(-3%)", offset: 0.75},
			{transform: "translateY(7%) scaleY(0.85)", offset: 0.9},
			{transform: "none", offset: 1},
		],
		options: {
			duration: 500,
			easing: "linear",
			fill: "none",
		},
		secondsBeforeNextBounce: () => {
			return _.random(3, 6, true);
		},
	},
	earnSomething: {
		hopOntoRoom: {
			makeKeyframes: locData => {
				const {prevLoc} = locData;
				return chapterPathMakeHopKeyframes(
					{
						x: prevLoc.beforeX,
						y: prevLoc.beforeY,
					},
					{
						x: prevLoc.x,
						y: prevLoc.y,
					}
				);
			},
			options: {
				duration: 750,
				easing: "linear",
				fill: "none",
			},
		},
		hopOffRoom: {
			makeKeyframes: locData => {
				const {prevLoc, currLoc, backwards} = locData;
				const x0 = prevLoc.x;
				const y0 = prevLoc.y;
				const x1 = currLoc.beforeX;
				const y1 = currLoc.beforeY;
				return chapterPathMakeHopKeyframes(
					{
						x: x0,
						y: y0,
					},
					{
						x: x1,
						y: y1,
					},
					{backwards}
				);
			},
			options: {
				duration: 750,
				easing: "linear",
				fill: "none",
			},
		},
	},
};

module.exports = {
	instructionsIn,
	instructionsOut,
	tutorialIn,
	tutorialOut,
	shake,
	progressStarPulse,
	shopExpand,
	shopRetract,
	backdropFadeOut,
	backdropFadeIn,
	entryFieldGlow,
	usernameGlow,
	checkboxGrow,
	starPop,
	celestialPop,
	glide,
	chapterPath,
};
